// extracted by mini-css-extract-plugin
module.exports = {"root":"DNDQTTkU68QPaF3UCWdd","alignCenter":"Bvo7uqYeASLOP2z6whA1","alignLeft":"fS3icQAL2mwcG50PRFgs","alignRight":"qtfHeqcVuJ2HsPvhqOFD"};